import { object, string } from "yup";

import { RecoverPasswordMessages } from "@/messages/recoverPassword/recover-password.messages";

import { RecoverPasswordFormData } from "./types";

type InputName = keyof RecoverPasswordFormData;

export const loginName: InputName = "login";

export const buildRecoverPasswordFormInitialData = (
  selectedEmail?: string
): RecoverPasswordFormData => {
  return {
    login: selectedEmail || "",
  };
};

export const buildRecoverPasswordFormSchema = (messages: RecoverPasswordMessages) =>
  object().shape({
    login: string().email(messages.errorInvalidEmail).required(messages.errorRequiredEmail),
  });
